// extracted by mini-css-extract-plugin
export default {"series-about-tab":"ShowAboutLayout_series-about-tab__hQvT0","slide-up":"ShowAboutLayout_slide-up__FiX6b"};